<template>
    <div class="overlay-container relative w-full h-full">
        <div
            :id="phraseId"
            class="word"
            @click="toggleLine"
            :class="{ paused: isPaused && phraseIsActive, active: phraseIsActive }"
        >
            <div class="line-dialogue px-2 py-0 text-lg">
                <div class="text-gray-600">{{ text.sentence_english }}</div>
                <div class="font-bold">
                    {{ text.sentence_foreign }}

                    <span v-if="text.footnote" class="tooltip"
                        ><sup class="superscript">*</sup>
                        <div
                            class="tooltip-text max-w-sm bg-black color-white text-white text-xs font-light p-5 -mt-6 -ml-6 rounded"
                        >
                            <span
                                class="triangle"
                                v-html="text.footnote"
                            ></span>
                            
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div
            v-show="isPaused && phraseIsActive"
            @click="toggleLine"
            class="flex w-full justify-between absolute top-0 right-0 bottom-0 left-0 px-2 opacity-100"
            :style="{height: overlayHeight}"
        >
<div style="background: rgb(234 234 234 / 52%);
    border-radius: 50px;
    border: 1px solid #ca7616;" 
    class="h-10 w-10 m-auto">  
<svg 
 class="h-6 w-6 cursor-pointer m-auto text-orange-800 hover:text-orange-500 relative opacity-100" fill="currentColor" 
 style="top: 0.45rem;left:0.08rem" version="1.1" viewBox="0 0 24 24" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<g id="info"/><g id="icons"><path d="M3.9,18.9V5.1c0-1.6,1.7-2.6,3-1.8l12,6.9c1.4,0.8,1.4,2.9,0,3.7l-12,6.9C5.6,21.5,3.9,20.5,3.9,18.9z" id="play"/></g></svg>
</div>

        </div>
    </div>
</template>

<script>
export default {
    props: ["phrase_num", "text", "phrase_times"],

    /**
     * audio (data) = HTMLAudio Object  
     * phrase_times (prop) = JSON obj that contains start and end times for each phrase 
     * phraseId (data) = Id of the line of dialogue handled by this component (e.g. "phrase2")
     * isPaused (computed) = boolean (true if audio is not playing)
     * phraseStart (computed) = audio start time of the line displayed by this component 
     * phraseEnd (computed) = end time of the line
     * phraseIsActive (computed) = boolean (true is audio.currentTime within phraseStart and phraseEnd)
     * overlayHeight (data) = dynamically sets height of the pause button overlay div
     **/

    data() {
        return {
            phraseId: "phrase" + this.phrase_num,
            audio: {id:null},
            overlayHeight: '54px'
        };
    },
    computed: {
        isPaused: {
            // get audio pause state from store
            get: function() {
                if (this.$store.state.audioPlaying) {
                    return false;
                } else {
                    return true;
                }
            },
            // set audio pause state 
            set: function(boolean) {
                this.$store.commit("SET_PLAYBACK_STATUS", !boolean);
            }
        },

        //True if audio.currentTime is within current phrase
        phraseIsActive: function(){

            return this.$store.state.currentTime  > this.phraseStart &&
                this.$store.state.currentTime  < this.phraseEnd;
            
        },

        phraseStart: function(){
            var phraseObj = this.phrase_times[this.phraseId];
            return phraseObj.start;
        },

        phraseEnd: function(){
            var phraseObj = this.phrase_times[this.phraseId];
            return phraseObj.end;
        },

    },    
    methods: {

        // Stop or start audio by clicking on a line of dialogue
        toggleLine(e) {
            var audio = this.audio;

            if (
                !audio.paused &&
                audio.currentTime > this.phraseStart &&
                audio.currentTime < this.phraseEnd
            ) {
                this.pauseAudio(audio);
            } else {
                audio.currentTime = this.phraseStart;
                this.playAudio(audio);
            }
        },

        pauseAudio(audio) {
            audio.pause();
            this.isPaused = true;
            //console.log("I am paused.");
        },
        
        playAudio(audio) {
            this.pauseAllAudio();
            audio.play();
            this.isPaused = false;
        },

        //Pause any other audio playing on the page before play start
        pauseAllAudio(){
            var audioElements = document.getElementsByTagName('audio');
            for (let audio of audioElements){
                this.isPaused = true;
                audio.pause();
            }
        },
        setOverlayHeight(){
            this.overlayHeight = document.getElementById(this.phraseId).offsetHeight;
        }

        /*
        // This pushes the line of the conversation where
        // the audio currently located (playing or paused)to our state
        setCurrentLine(){
            var audio = document.getElementById("sync-dialogue");
            for (let [id, time] of Object.entries(this.phrase_times)) {
                if (
                    audio.currentTime > time.start &&
                    audio.currentTime < time.end
                ) {
                    this.$store.commit("SET_CURRENT_LINE", id);
                }
            }
        },
        
        //Sync text highlighting on main dialogue
        //phraseTimes var is already loaded globally
        syncTextHighlights(audio) {
        
            var className = "active";
            for (let [id, time] of Object.entries(phraseTimes)) {
                var target = document.getElementById(id);
                if (
                    audio.currentTime > time.start &&
                    audio.currentTime < time.end
                ) {
                    this.$store.commit("SET_CURRENT_LINE", id);
                    if (!target.classList.contains(className)) {
                        target.classList.add(className);
                    }
                } else if (target && target.classList.contains(className)) {
                    target.classList.remove(className);
                }
            }
        },

        //Cleanup any lingering text highlights
        removeTextHighlights() {
            if (audio.id == "sync-dialogue") {
                var className = "active";
                for (let [id, time] of Object.entries(phraseTimes)) {
                    var target = document.getElementById(id);
                    if (target && target.classList.contains(className)) {
                        target.classList.remove(className);
                    }
                }
            }
        },
        currentLine: function(){
            var line = 0;
            //var audio = document.getElementById("sync-dialogue");
            for (let [id, time] of Object.entries(JSON.parse(this.phrase_times))) {
                if (
                    this.$store.state.currentTime > time.start &&
                    this.$store.state.currentTime < time.end
                ) {
                    line = id;
                }
            }
            return line;
        },
        */
    },
    mounted: function() {

        // nextTick = code will run only after the entire view has been rendered
        this.$nextTick(function() {     
            
            this.audio = document.getElementById("sync-dialogue");

            //Sync height of overlay to height of phrase when view is intially rendered and on window resize
            this.setOverlayHeight();
            window.addEventListener("resize", this.setOverlayHeight);

        });
    },
    destroyed: function(){
        window.removeEventListener("resize", this.setOverlayHeight);
    }
};
</script>

<style>

</style>
